import React from 'react';
import { useUndoRedoContext } from '../../../context/UndoRedoContext';

/**
 * Icons for the history section
 */
const HistoryIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
    <path d="M3 3v5h5" />
    <path d="M12 7v5l4 2" />
  </svg>
);

const SearchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

/**
 * SidebarHistorySection
 *
 * Mission search + history at the bottom of the sidebar.
 * Undo/redo stay on the keyboard (Ctrl+Z / Ctrl+Y / Ctrl+Shift+Z) —
 * no need for chrome everyone already knows.
 * Only visible when a campaign or template is active.
 */
const SidebarHistorySection = () => {
  const {
    undoCount,
    redoCount,
    onToggleHistory,
    onOpenMissionSearch,
    isActive,
  } = useUndoRedoContext();

  // Don't render if no campaign/template is active
  if (!isActive) {
    return null;
  }

  return (
    <div className="sidebar-history">
      {onOpenMissionSearch && (
        <button
          className="sidebar-history__btn"
          onClick={onOpenMissionSearch}
          title="Search missions (Ctrl+K)"
        >
          <SearchIcon />
        </button>
      )}
      <button 
        className={`sidebar-history__btn ${(undoCount + redoCount) > 0 ? 'sidebar-history__btn--has-items' : ''}`}
        onClick={onToggleHistory} 
        title="Show history"
      >
        <HistoryIcon />
        {(undoCount + redoCount) > 0 && (
          <span className="sidebar-history__count">{undoCount + redoCount}</span>
        )}
      </button>
    </div>
  );
};

export default SidebarHistorySection;
